"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasStatusCantPlay = exports.hasStatusOnField = exports.hasStatusFall = exports.hasStatusInjury = exports.hasStatusCanAssist = exports.hasStatusStanding = exports.hasStatusTacleZone = exports.hasStatusCanStandup = exports.hasStatusCanFaceup = exports.PLAYER_STATUS = void 0;
var PLAYER_STATUS;
(function (PLAYER_STATUS) {
    PLAYER_STATUS[PLAYER_STATUS["STANDING"] = 0] = "STANDING";
    PLAYER_STATUS[PLAYER_STATUS["KNOCKED_DOWN"] = 1] = "KNOCKED_DOWN";
    PLAYER_STATUS[PLAYER_STATUS["STUNNED"] = 2] = "STUNNED";
    PLAYER_STATUS[PLAYER_STATUS["RESERVE"] = 3] = "RESERVE";
    PLAYER_STATUS[PLAYER_STATUS["KO"] = 4] = "KO";
    PLAYER_STATUS[PLAYER_STATUS["CASUALTY"] = 5] = "CASUALTY";
    // For other casuality (death), update all playerTo.status === PLAYER_STATUS.CASUALTY
    PLAYER_STATUS[PLAYER_STATUS["SENDOFF"] = 6] = "SENDOFF";
    PLAYER_STATUS[PLAYER_STATUS["BONE_HEAD"] = 7] = "BONE_HEAD";
    PLAYER_STATUS[PLAYER_STATUS["EYE_GOUGED"] = 8] = "EYE_GOUGED";
    PLAYER_STATUS[PLAYER_STATUS["BLOODLUST"] = 9] = "BLOODLUST";
})(PLAYER_STATUS || (exports.PLAYER_STATUS = PLAYER_STATUS = {}));
const hasStatusCanFaceup = (player) => {
    return player.status === PLAYER_STATUS.STUNNED;
};
exports.hasStatusCanFaceup = hasStatusCanFaceup;
const hasStatusCanStandup = (player) => {
    return player.status === PLAYER_STATUS.KNOCKED_DOWN;
};
exports.hasStatusCanStandup = hasStatusCanStandup;
const hasStatusTacleZone = (player) => {
    // BONE_HEAD doesn't have tackle zone, EYE_GOUGED keeps tackle zone
    return (player.status === PLAYER_STATUS.STANDING ||
        player.status === PLAYER_STATUS.EYE_GOUGED ||
        player.status === PLAYER_STATUS.BLOODLUST);
};
exports.hasStatusTacleZone = hasStatusTacleZone;
const hasStatusStanding = (player) => {
    return (player.status === PLAYER_STATUS.STANDING ||
        player.status === PLAYER_STATUS.BONE_HEAD ||
        player.status === PLAYER_STATUS.EYE_GOUGED ||
        player.status === PLAYER_STATUS.BLOODLUST);
};
exports.hasStatusStanding = hasStatusStanding;
const hasStatusCanAssist = (player) => {
    return player.status !== PLAYER_STATUS.EYE_GOUGED;
};
exports.hasStatusCanAssist = hasStatusCanAssist;
const hasStatusInjury = (player) => {
    return (player.status === PLAYER_STATUS.KO ||
        player.status === PLAYER_STATUS.CASUALTY);
};
exports.hasStatusInjury = hasStatusInjury;
const hasStatusFall = (player) => {
    return (player.status === PLAYER_STATUS.KNOCKED_DOWN ||
        player.status === PLAYER_STATUS.STUNNED);
};
exports.hasStatusFall = hasStatusFall;
const hasStatusOnField = (player) => {
    return (0, exports.hasStatusStanding)(player) || (0, exports.hasStatusFall)(player);
};
exports.hasStatusOnField = hasStatusOnField;
const hasStatusCantPlay = (player) => {
    return (player.status === PLAYER_STATUS.SENDOFF ||
        player.status === PLAYER_STATUS.CASUALTY);
};
exports.hasStatusCantPlay = hasStatusCantPlay;
